import { TagComponent } from "ecsy";

/** Advance the turn */
export class Advance extends TagComponent {}
